// @ts-nocheck
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getOperatingUnitWithPermission } from '@store/HR/Organizations/organizationSlice';

const useGetOperatingUnitWithPermission = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.length === 0) {
      dispatch(getOperatingUnitWithPermission());
    }
  }, []);

  const {
    OperatingUnitList: data,
    loadingOperatingUnit: loading,
    errorOperatingUnit: error
  } = useSelector(state => state.Organizations);

  // const BranchOrgOptions =
  //   data &&
  //   data?.map((item) => ({
  //     value: item.id,
  //     label: i18n.language === 'en' ? item.name : item.name2,
  //   }));

  const OperatingUnitOptions = useMemo(
    () =>
      data &&
      data?.map(branch => ({
        label: i18n.language === 'en' ? branch.name : branch.name2,
        value: branch.id
      })),
    [data]
  );

  return { data, OperatingUnitOptions, loading, error };
};

export default useGetOperatingUnitWithPermission;
